import styled from 'styled-components';
import {
  fontFamilyRoboto,
} from '@components/hoc/Theme/Theme.styled';

export const FieldWrapper = styled.section`
  margin-bottom: 5px;
  width: 100%;
  margin: 0 auto 5px auto;
  position: relative;
  @media (max-width: 450px) {
    width: 100%;
    margin: 12px 20px 5px auto;
  }
`;

export const TitleLabel = styled.label`
  font-size: 13px !important;
  font-family: ${fontFamilyRoboto};
  letter-spacing: 0.5px !important;
  display: flex;
  margin: 0 auto;
  width: 100%;
  color: ${(props) => (props.$iserror ? 'red' : fontFamilyRoboto)};
  font-weight: ${(props) => (props.$iserror ? 'bold' : null)};
`;

export const SubLabel = styled.i`
  font-size: 12px;
  margin-left: 3px;
`;

export const Required = styled.span`
  color: red;
  margin: 2px;
  margin: -3px 0px 0px 5px;
  font-weight: bold;
  &:after {
    content: '*';
  }
`;

export const InputContainer = styled.label`
  position: relative;
  display: inline-flex;
  width: 100%;
`;
